export const LOCATION_SUD_TERM_ID = 241
